import React from 'react';
import HubspotForm from 'react-hubspot-form';
import { appendTooltip } from '@commons/append-tooltip/appendTooltip';
import { privatePolicyInfo } from '@commons/append-tooltip/payload';
import { LoadingSpinner } from '@commons/loading-spinner/LoadingSpinner';
import './golang-form.module.scss';

export const GolangForm = ({ runSetFormSubmitted }) => {
  const policyInfo = privatePolicyInfo.type3;
  return (
    <HubspotForm
      region="na1"
      portalId="5206705"
      formId="45cf9e49-7887-4e53-a020-ad8cfb77ad17"
      loading={<LoadingSpinner />}
      onReady={() => appendTooltip('#golangDownloadForm', policyInfo)}
      onSubmit={() => undefined}
      onFormSubmitted={() => {
        runSetFormSubmitted();
      }}
    />
  );
};
